module.exports = __webpack_public_path__ + "58de4d3797ee8815dce409bd1afb7708.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/corina_schwingruber_ilic.jpg
// module id = 110
// module chunks = 0